<!-- Vertical Menu -->
@if (menuType === 'vertical-menu') {
  <vertical-menu></vertical-menu>
}
<!--/ Vertical Menu -->

<!-- Horizontal Menu -->
@if (menuType === 'horizontal-menu') {
  <horizontal-menu></horizontal-menu>
}
<!--/ Horizontal Menu -->
